<template>
  <base-hm-input v-tooltip="tooltip"
                 :id="$attrs['id']"
                 :class="[
                   $attrs['class'],
                   { 'has-inline-icon-left': hasSlot('icon-inline-left') },
                   { 'has-inline-icon-right': hasSlot('icon-inline-right') },
                   { 'component__hm-select--visible': selectVisible },
                   { 'component__hm-multiselect--autocomplete': hideActionButtons },
                   { 'component__hm-multiselect--inline': inline },
                   { 'component__hm-multiselect--open': opened }
                 ]"
                 :style="iconCountStyleVariables"
                 :label="label"
                 :help="help"
                 :has-focus="hasFocus"
                 :hover="hover"
                 :is-empty="false"
                 :name="name"
                 :cols="cols"
                 :hidden="hidden"
                 :disabled="disabledCombined">
    <v-multiselect v-if="inputLoaded"
                   ref="autocomplete"
                   v-model="childSelectValue"
                   :select-label="$t('inputs.hmMultiselect.selectLabel')"
                   :select-group-label="$t('inputs.hmMultiselect.selectGroupLabel')"
                   :selected-label="$t('inputs.hmMultiselect.selectedLabel')"
                   :deselect-label="$t('inputs.hmMultiselect.deselectLabel')"
                   :deselect-group-label="$t('inputs.hmMultiselect.deselectGroupLabel')"
                   :limit-text="(cnt) => $t('inputs.hmMultiselect.limitText', [cnt])"
                   :limit="limit"
                   :show-no-options="false"
                   :show-no-results="false"
                   :show-labels="true"
                   :disabled="disabledCombined"
                   :options="selectItems"
                   :validate="validate"
                   :multiple="true"
                   :clear-on-select="false"
                   :preserve-search="true"
                   :placeholder="label"
                   :label="label"
                   :name="name"
                   :custom-label="getOptionLabel"
                   :allow-empty="true"
                   :searchable="false"
                   :preselect-first="false"
                   :track-by="valueExpression"
                   :close-on-select="false"
                   class="hm-input__select hm-input__select--multiselect"
                   @open="opened = true"
                   @close="opened = false">
      <template slot="singleLabel" slot-scope="props"><span class="option__title">{{ getOptionLabel(props.option) }}</span></template>
      <template slot="option" slot-scope="props"><span class="option__title">{{ getOptionLabel(props.option) }}</span></template>
    </v-multiselect>
    <!--    <v-select v-if="inputLoaded"-->
    <!--              ref="autocomplete"-->
    <!--              v-model="childSelectValue"-->
    <!--              :data-vv-as="label"-->
    <!--              :data-vv-name="name"-->
    <!--              :disabled="disabledCombined"-->
    <!--              :options="selectItems"-->
    <!--              :validate="validate"-->
    <!--              :get-option-label="getOptionLabel"-->
    <!--              :select-on-tab="true"-->
    <!--              :close-on-select="false"-->
    <!--              :multiple="true"-->
    <!--              :label="'name'"-->
    <!--              :searchable="false"-->
    <!--              class="hm-input__select hm-input__select&#45;&#45;vselect"-->
    <!--              type="text"-->
    <!--              @search:focus="onFocus"-->
    <!--              @search:blur="onBlur">-->
    <!--      <span v-if="hasSlot('option')" slot="option" slot-scope="option" @mousedown.prevent.stop="handleOptionClicked(option)">-->
    <!--        <slot :option="option" :labelKey="'name'" name="option" />-->
    <!--      </span>-->
    <!--      <span v-else slot="option" slot-scope="option" @mousedown.prevent.stop="handleOptionClicked(option)">-->
    <!--        <template v-if="disabledOptions.includes(option.id)"><s>{{ getOptionLabel(option) }}</s></template>-->
    <!--        <template v-else>{{ getOptionLabel(option) }}</template>-->
    <!--      </span>-->
    <!--      <span slot="spinner" slot-scope="mutableLoading">-->
    <!--        <div class="spinner">{{ $t('inputs.hmMultiselect.loading') }} {{ mutableLoading }}</div>-->
    <!--      </span>-->
    <!--      <span slot="no-options">{{ $t('inputs.hmMultiselect.noResults') }}</span>-->
    <!--      <span slot="selected-option-container" slot-scope="{ option }">-->
    <!--        <span class="selection-option-label">{{ getOptionLabel(option) }}</span>-->
    <!--      </span>-->
    <!--    </v-select>-->
    <div :class="[{ 'hm-input__icon--input-hover': hover }, { 'hm-input__icon--input-focus': hasFocus}]" class="hm-input__icon__wrapper  hm-input__icon__wrapper--left" @click="$event.stopPropagation();">
      <slot :hover="hover" :focus="hasFocus" :value="childSelectValue" name="icon-inline-left"></slot>
    </div>
    <!-- buttons outside input - on the right -->
    <div :class="[{ 'hm-input__icon--input-hover': hover }, { 'hm-input__icon--input-focus': hasFocus}]" class="hm-input__icon__wrapper  hm-input__icon__wrapper--right" @click="$event.stopPropagation();">
      <slot :hover="hover" :focus="hasFocus" :value="childSelectValue" name="icon-inline-right"></slot>
    </div>
  </base-hm-input>
</template>

<script>

import {
  isNil,
  isArray,
  isObject,
  template,
  isString,
  isEmpty,
  find,
  debounce,
  isEqual,
  isFunction,
  differenceWith, isEqualWith,
} from 'lodash';
import HmInputMixin from '@/mixins/HmInputMixin';
import LocaleMixin from '@/mixins/LocaleMixin';
import TimerMixin from '@/mixins/TimerMixin';

export default {
  name: 'HmMultiselect',

  mixins: [HmInputMixin, LocaleMixin, TimerMixin],

  props: {
    value: {
      required: true,
    },
    valueExpression: {
      type: String,
      default: 'id',
    },
    autocompleteUrl: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    labelExpression: {
      // type: String,
      // eslint-disable-next-line no-template-curly-in-string
      default: '${option.name}',
    },
    options: {
      default: null,
    },
    disabledOptions: {
      type: Array,
      default: () => [],
    },
    inline: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 2,
    },
  },

  data: function () {
    return {
      hover: false,
      loaded: false,
      selectItems: [],
      childSelectValue: null,
      opened: false,
    };
  },

  computed: {
    isValueEmpty: function () {
      return isEmpty(this.internalValue);
    },
    hideActionButtons: function () {
      return !isEmpty(this.autocompleteUrl);
    },
    selectVisible: function () {
      return this.hasFocus;
    },
    iconCountLeft: function () {
      let slot = this.getSlot('icon-inline-left');
      if (isFunction(slot)) slot = slot();

      if (isNil(slot)) return 0;
      else if (isArray(slot)) return slot.filter(it => typeof it.tag !== 'undefined').length;
      else return 1;
    },
    iconCountRight: function () {
      let slot = this.getSlot('icon-inline-right');
      if (isFunction(slot)) slot = slot();

      if (isNil(slot)) return 0;
      else if (isArray(slot)) return slot.filter(it => typeof it.tag !== 'undefined').length;
      else return 1;
    },
    iconCountStyleVariables: function () {
      return {
        '--icons-left': this.iconCountLeft,
        '--icons-right': this.iconCountRight,
      };
    },
    tooltip() {
      if (!isEmpty(this.autocompleteUrl) || isEmpty(this.value)) {
        return {
          title: this.$t('inputs.hmMultiselect.nothingSelected'),
          delay: 0,
          theme: 'light',
          placement: 'top',
          positionFixed: true,
          html: true,
          trigger: 'none',
          touch: false,
        };
      }

      let title = '';

      if (!isEmpty(this.value)) {
        title = this.value.map((val) => {
          if (isArray(this.options)) {
            const option = this.options.find(it => it[this.valueExpression] === val);
            if (!isObject(option)) return '-';
            const args = this.getOptionArgs(option);
            return isFunction(this.labelExpression) ? this.labelExpression(args) : template(this.labelExpression)(args);
          } else if (isObject(this.options)) {
            return this.options[val] || '-';
          } else {
            return '-';
          }
        }).join('<br />');
      }

      if (isEmpty(title)) return {};

      return {
        title: title,
        delay: 0,
        theme: 'light',
        placement: 'top',
        positionFixed: true,
        html: true,
        trigger: 'hover',
        touch: false,
      };
    },
  },


  watch: {
    options: function (newVal, oldValue) {
      this.updateSelectItems();
    },
    childSelectValue: function (newVal, oldVal) {
      const tmp = this.childSelectValue.map(it => it[this.valueExpression]);

      if (!isEqual(tmp, this.internalValue)) {
        this.internalValue = tmp;
      }
    },
    internalValue: function (newVal, oldVal) {
      const tmp = this.selectItems.filter(it => (isNil(this.internalValue) ? false : this.internalValue.includes(it[this.valueExpression])));

      function comp(x, y) {
        if (isString(x) || isString(y)) return x === y;
        if (isArray(x) || isArray(y)) return isEmpty(differenceWith(x, y, isEqual));
        if (isObject(x) || isObject(y)) return isEqual(x, y);
        return x === y;
      }

      if (!isEqualWith(tmp, this.childSelectValue, comp) || (tmp || { length: 0 }).length !== (this.childSelectValue || { length: 0 }).length) {
        this.childSelectValue = tmp;
      }
    },
  },

  created: function () {
    this.inputLoaded = false;

    this.updateSelectItems();
    this.inputLoaded = true;

    if (!isNil(this.internalValue)) {
      this.childSelectValue = this.selectItems.filter(it => (isNil(this.internalValue) ? false : this.internalValue.includes(it[this.valueExpression])));
    }
  },


  methods: {
  //   onClick: function (e) {
  //     if (e.target.classList.contains('selected-tag')) return;
  //     if (isNil(e.target.closest('.vs__selected-options'))) return;
  //     if (!isNil(this.$refs) && !isNil(this.$refs.autocomplete)) {
  //       if (this.$refs.autocomplete.open) {
  //         this.$refs.autocomplete.$refs.search.blur();
  //       } else {
  //         this.$refs.autocomplete.open = true;
  //         this.$refs.autocomplete.$refs.search.focus();
  //       }
  //     }
  //   },
  //   handleOptionClicked: function (option) {
  //     if (this.disabledOptions.includes(option) || this.disabledOptions.includes(option.id)) return;
  //     if (!isNil(this.$refs) && !isNil(this.$refs.autocomplete)) {
  //       if (!this.$refs.autocomplete.isOptionSelected(option)) {
  //         this.$refs.autocomplete.select(option);
  //       } else {
  //         this.$refs.autocomplete.deselect(option);
  //       }
  //     }
  //   },
    hasSlot: function (slotName) {
      return !isNil(this.$slots[slotName]) || !isNil(this.$scopedSlots[slotName]);
    },
    getSlot: function (slotName) {
      return !isNil(this.$slots[slotName]) ? this.$slots[slotName] : this.$scopedSlots[slotName];
    },
    isNil: function (arg) {
      return isNil(arg);
    },
    isEmptyString: function (arg) {
      return isEmpty(arg);
    },
    updateSelectItems: function (event) {
      const $vm = this;
      const queryString = event;

      if (isObject(this.options)) {
        this.selectItems = Object.entries(this.options)
          .map(([k, v]) => {
            if (isString(v)) {
              return {
                name: v,
                id: k,
              };
            } else {
              return {
                ...v,
                id: v.id || k,
              };
            }
          });
      } else if (isArray(this.options)) {
        this.selectItems = this.options;
      }
    },
    getOptionArgs: function (option) {
      const args = {
        option: option,
        $t: this.$t,
        _i18n: this._i18n,
        $shortLocale: this.$shortLocale,
        toDate: value => (isNil(value) ? '' : new Intl.DateTimeFormat(
          window.i18n.locale,
          {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          },
        ).format(this.$moment(value, 'YYYYMMDD')
          .toDate())),
      };
      return args;
    },
    getOptionLabel: function (option) {
      if (isObject(option)) {
        const args = this.getOptionArgs(option);

        if (isFunction(this.labelExpression)) {
          return this.labelExpression(args);
        } else {
          return template(this.labelExpression)(args);
        }
      } else if (this.autocompleteUrl) {
        return option;
      } else {
        return option;
      }
    },
    // onClickOutside(evt) {
    //   let closed = false;
    //   if (evt && evt.target && this.$refs.autocomplete.open) {
    //     if (isNil(evt.target.closest('.component__hm-multiselect'))) {
    //       this.setTimeout(() => {
    //         if (this.$refs.autocomplete.open) {
    //           this.$refs.autocomplete.closeSearchOptions();
    //           closed = true;
    //         }
    //       });
    //     }
    //   }
    //   if (!closed && evt && !isEmpty(evt.path)) {
    //     try {
    //       if (evt.path.filter(it => it.classList.includes('component__hm-multiselect')).length > 0) {
    //         this.$refs.autocomplete.closeSearchOptions();
    //         closed = true;
    //       }
    //     } catch (e) { /* ignore */ } // could fail if classList is null
    //   }
    // },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>

<style lang="scss">
  @import '~styles/import';
  @import '~vue-multiselect/dist/vue-multiselect.min';

  #hm--vue {

    .component__hm-multiselect {
      .hm-input__icon__wrapper {
        height: calc(100% - 2rem);
        min-height: 3.2rem;

        .inline-button {
          height: 100%!important;
          min-height: 3.2rem;

          .hm-icon {
            height: 100%;
            min-height: 3.2rem;
          }
        }
      }

      &--open {
        .hm-input__label, .hm-input__icon__wrapper {
           z-index: 50;
        }
        z-index: 50;
      }

      .hm-input__select.hm-input__select--multiselect {
        min-height: 3.2rem;
        //max-height: 3.2rem!important;
        height: auto;
        position: relative;
        padding-bottom: 0;
        //max-height: max-content;
        &.multiselect {
          &--active {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;

            .multiselect {
              &__select {
                transform: none;
              }
            }
          }
        }

        .multiselect {
          &__strong {
            margin-bottom: 0;
          }
          &__content {
            &-wrapper {
              border-top: none;
              border-top-left-radius: 0;
              border-top-right-radius: 0;
              font-size: 1.4rem;
              width: calc(100% + 4px);
              left: -2px;
              margin-top: 1px;
            }
          }
          &__placeholder {
            height: 1.4rem;
            min-height: 1.4rem;
            max-height: 1.4rem;
            line-height: 1.4rem;
          }
          &__element {
            font-size: 1.4rem;
          }
          &__option {
            padding-left: 0.6rem;
            line-height: 3.2rem;
            min-height: 3.2rem;
            max-height: 3.2rem;
            padding-top: 0;
            padding-bottom: 0;
            border-bottom: 1px solid $lightgray;
            overflow: hidden;
            &:after {
              //display: none;
              font-size: 1.4rem;
              height: 3.2rem;
              line-height: 3.2rem;
              bottom: 1px;
            }
          }
          &__tag {
            //background: $mint;
            background: none!important;
            line-height: normal;
            border: 1px solid $middlegray;
            color: $text;
            padding: 0.5px 29px 0.5px 6px;
            margin-bottom: 0!important;
            font-size: 1.4rem;
            border-radius: 0.3rem;
            background: $lightgray;
            //background: red;
            &-icon {
              background: #fff;
              transition: background ease 0.3s;
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
              border-left: 1px solid $middlegray;
              border-top-right-radius: 0.3rem;
              border-bottom-right-radius: 0.3rem;
              &:hover {
                //background: $middlemint;
                //background: none;
                //background: $mint;

                &:after {
                  background: none!important;
                  //color: $lightgray;
                  //color: $mint;
                  //color: $white;
                  color: $text;
                  //&:before {
                  //  background-image: url(~svg/collapse_active.svg) !important;
                  //}
                }
              }
              &:after {
                color: $white;
                color: $text;
                background: none;
                color: $middlegray;
                font-size: 140%;
                font-weight: bold;
                //background-image: url(~svg/collapse.svg) !important;
                //background-size: 200%;
                transition: color ease 0.3s;
              }
            }
          }
          &__tags {
            border: none;
            padding: 0;
            padding-right: calc(var(--icons-right) * 3.2rem + 3.2rem);
            background: none;
            //height: 2.2rem;
            //overflow: hidden;
            min-height: 2.0rem;
            &-wrap {
              display: contents;
            }
          }
          &__select {
            position: absolute;
            top: 0;
            right: calc(var(--icons-right) * 3.2rem);
            bottom: 0;
            height: auto;
            //height: 3.2rem;
            width: 3.2rem;
            border-left: 1px solid $middlegray;
            &:before {
              background-image: url(~svg/collapse.svg)!important;
              border: none;
              background-position: center -0.3rem;
              background-repeat: no-repeat;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0.2rem;
            }
          }
        }
      }

      .v-select.disabled .dropdown-toggle, .v-select.disabled .dropdown-toggle .clear, .v-select.disabled .dropdown-toggle input, .v-select.disabled .open-indicator, .v-select.disabled .selected-tag .close {
        background-color: $lightgray;
        height: 3.0rem;
        border-radius: 0.3rem;
      }

      .v-select.disabled {
        cursor: not-allowed;
        .dropdown-toggle {
          pointer-events: none;
        }
        .dropdown-menu {
          display: none!important;
        }
      }

      .hm-input--disabled {
        .inline-button {
          background-color: $white;
          border: 1px solid $middlegray;

          &:last-child {
            border-top-right-radius: 0.3rem;
            border-bottom-right-radius: 0.3rem;
          }
        }
      }

      .inline-button {
        @include icon-color($middlegray);
        @include icon-hover($text);
        &:hover {
          cursor: pointer;
        }
      }

      &.has-inline-icon-left {
        .vs__selected-options {
          padding-left: 0;
        }
      }

      .dropdown-toggle {
        border: none !important;
        padding-left: calc(var(--icons-left) * 3.2rem);
        padding-right: calc(var(--icons-right) * 3.2rem);
      }

      .v-select .dropdown-menu {
        li {
          position: relative;
        }
        padding-top: 1px;
        & > .highlight > a {
          background: $lightmint;
          color: $text;
        }
        & > .active > a {
          color: $text;
          background-image: url(~svg/save.svg)!important;
          background-color: $lightgray;
          background-repeat: no-repeat;
          background-position-x: right;
          background-position-y: center;
          min-height: 28px;

          span {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: block;
            padding-left: 12px;
            padding-right: 12px;
            padding-top: 4px;
          }
        }
        a {
          padding: 4px 12px;
        }

        li:not(:last-of-type) {
          border-bottom: 1px solid $lightmiddlegray;
          &.highlight {
            border-bottom: 1px solid $middlemint;
            position: relative;
            &:before {
              content: '';
              position: absolute;
              top: -1px;
              left: 0;
              width: 100%;
              height: 1px;
              display: block;
              background-color: $middlemint;
            }
          }
        }
        .gravatar__wrapper img {
          border: 1px solid $middlemint;
        }
      }

      .v-select {
        &.open {
          .open-indicator {
            &:before {
              background-image: url(~svg/collapse_active.svg)!important;
            }
          }
        }
      }

      input[type=search] {
        padding: 0;
      }

      .vs__selected-options {
        max-width: calc(100% - 2 * 3.2rem);
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-left: 1rem;
        padding-top: 0.3rem;
        max-height: 3.2rem;

        > span {
          display: inline-flex;

          .selection-option-label {
            margin-right: 1.2ch;
            position: relative;

            &:after {
              content: ',';
              position: absolute;
              right: -0.4rem;
              bottom: 0;
            }
          }

          &:last-of-type {
            .selection-option-label {
              margin-right: 0;
              &:after {
                content: '';
                display: none;
              }
            }
          }
        }
      }
      .vs__selected-options--old {
        max-width: calc(100% - 2 * 3.2rem);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-left: 1rem;
        max-height: 3.2rem;
        display: inline-grid;
        grid-template-rows: 1fr;
        grid-template-columns: repeat(auto-fit, minmax(6rem, max-content));
        grid-auto-flow: column;

        * {
          height: 3.2rem;
          padding-top: 0.9rem;
          padding-bottom: 0.5rem;
          margin: 0;
          display: block;
          max-width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          line-height: 1.6rem;
          border: none;
          padding-left: 0;
          padding-right: 0;

          &:focus {
            height: 3.2rem !important;
            padding-top: 0.9rem !important;
            padding-bottom: 0.5rem !important;
            margin: 0 !important;
            display: block !important;
            max-width: 100% !important;
            overflow: hidden !important;
            white-space: nowrap !important;
            text-overflow: ellipsis !important;
            line-height: 1.6rem !important;
            border: none !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
          }
        }
      }

      .vs__actions {
        padding: 0;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-areas: 'clear open';
        width: 2 * 3.2rem;
        min-width: 2 * 3.2rem;
        max-width: 2 * 3.2rem;
        height: 3.2rem;

        .clear {
          width: 3.2rem;
          height: 3.2rem;
          padding: 0;
          margin: 0;
          grid-area: 'clear';

          span {
            width: 3.2rem;
            height: 3.2rem;
            display: block;
            content: '';
            color: transparent;
            background-image: url(~svg/delete.svg);
            background-position: center center;
            background-repeat: no-repeat;
            position: relative;

            &:hover {
              background-image: url(~svg/delete_hover.svg);
            }
          }
        }

        .open-indicator {
          width: 3.2rem;
          height: 3.1rem;
          grid-area: open;
          overflow: hidden;
          &:before {
            width: 3.2rem;
            height: 3.2rem;
            transform: none !important;
            content: ' ';
            border: none;
            background-image: url(~svg/collapse.svg);
            background-position: center center;
            background-repeat: no-repeat;
            border-left: 1px solid $middlegray;
          }
        }
      }

      &--inline {
        max-height: 3.2rem!important;
        .vs__selected-options {
          padding-top: 0!important;
          line-height: 3.2rem!important;
        }
        .hm-input__select {
          &--multiselect {
            max-height: 3.2rem;
          }
          .multiselect {
            &__tags {
              margin-top: -2px;
              line-height: 0;
              overflow: hidden;
            }
          }
        }
      }

      &--autocomplete {
        .vs__actions {
          display: none;
        }

        .vs__selected-options {
          max-width: calc(100%);
        }
      }

      .selected-tag {
        border-radius: 1.3rem;
        padding-left: 1rem;
        padding-right: 3.2rem;
        margin-right: 0.6rem;
        display: block;
        position: relative;
        height: 2.6rem;
        margin-top: 0.3rem;
        padding-top: 0.6rem;

        .close {
          color: $black;

          position: absolute;
          top: -0.3rem;
          right: 0.6rem;
          width: 2.6rem;
          height: 2.6rem;
          background-image: url(~svg/delete.svg);
          text-shadow: none;
          opacity: 1;

          &:hover {
            background-image: url(~svg/delete_hover.svg);
          }

          span {
            display: none;
          }
        }
      }
    }
  }

  #hm--vue .component__hm-multiselect .hm-input--disabled .hm-input__select--vselect .vs__selected-options {
    top: -5px;
    height: 36px;
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmMultiselect.vue